const SuppliedGoods = [
  {
    path: '/ecommerce/supply',
    name: 'supplied-goods',
    component: () => import(/* webpackChunkName: "supplied-goods-base" */ './SupplyView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Supplied Goods',
          path: '/inventory/supplied-goods',
        },
      ],
    },
    children: [
      {
        path: 'goods',
        name: 'Supplied Goods',
        component: () => import(/* webpackChunkName: "all-supplied-goods" */ './components/Supplies.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Supplied Goods',
              path: '/ecommerce/supply/goods',
            },
          ],
        },
      },
      {
        path: 'goods/new',
        name: 'new-supply',
        component: () => import(/* webpackChunkName: "create-supplied-goods" */ './components/NewSupply.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'New Supply',
              path: '/ecommerce/supply/goods/new',
            },
          ],
        },
      },
      {
        path: 'goods/:id/details',
        name: 'supply-details',
        component: () => import(/* webpackChunkName: "details-supplied-goods" */ './components/SupplyDetails.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Supply Details',
              path: '/ecommerce/supply/goods/:id/details',
            },
          ],
        },
      },
      {
        path: 'goods/:id/edit',
        name: 'edit_supply',
        component: () => import(/* webpackChunkName: "edit-supplied-goods" */ './components/UpdateSupply.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Edit Supply',
              path: '/ecommerce/supply/goods/:id/edit',
            },
          ],
        },
      },
    ],
  },
];

export default SuppliedGoods;
